module.exports = __webpack_public_path__ + "img/02-04-img-02@2x.50a3bfab.png";